import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ab05a75&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=0ab05a75&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab05a75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab05a75')) {
      api.createRecord('0ab05a75', component.options)
    } else {
      api.reload('0ab05a75', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ab05a75&scoped=true", function () {
      api.rerender('0ab05a75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SideHelper/Welfare/index.vue"
export default component.exports